
import {Item_Size} from "../utils/classes/item/Size";
import {Item_Type} from "../utils/classes/item/Types";
// import {Date_Util} from "./filter.date";

export class Util_Filter_Folder {

    static undef;

    public static meta(entry) {
        let ret = '', arr = [], obj = {child_num: '', size: ''};


        if (Item_Type.isFolderType(entry.item_type)) {
            let num = Math.ceil(entry.child_num);
            if (num > 0) {
                arr.push(`${num} 个`);
                // obj.child_num = `${num} 个`;
            } else {
                arr.push('空');
                // obj.child_num = '空';
            }
            obj.child_num = `${num}`;
        }

        let size = 0;
        if (entry.item && entry.item.storage) {
            size = Math.ceil(entry.item.storage.size || 0);
        } else if (entry.size) {
            size = Math.ceil(entry.size);
        }
        // obj.size = `${Item_Size.intToHuman(size).int}`;  // debug 专用
        obj.size = `${Item_Size.intToHuman(size).human}`;
        arr.push(`${Item_Size.intToHuman(size).human}`);

        // ret = arr.length ? arr.join(', ') : '';

        return  obj;
        // return  ret;
    }

}


